import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailSettingService {

  constructor(private httpClient: HttpClient, private router: Router, private toastr: ToastrService) { }
  private apiUrl = environment.apiUrl;
  getEmailSettingList(): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/EmailSetting/GetAllEmailLists`).pipe(
      catchError(this.error)
    );
  }
  createEmailSettings(emailModel:any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/EmailSetting/EmailSetting`,emailModel).pipe(
      catchError(this.error)
    );;
  }
  getEmailSettingById(id:number): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/EmailSetting/GetEmailSettingById?id=${id}`).pipe(
      catchError(this.error)
    );;
  }
  updateEmailSetting(emailModel:any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/EmailSetting/UpdateEmailSetting`,emailModel).pipe(
      catchError(this.error)
    );;
  }
  //send test mail
  sendTestMail(reciversEmail:any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/EmailSetting/SendTestMail`,{reciversEmail}).pipe(
      catchError(this.error)
    );;
  }
  // Handle Errors
  error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
